import { render, staticRenderFns } from "./TollList.vue?vue&type=template&id=46138e0b"
import script from "./TollList.vue?vue&type=script&lang=js"
export * from "./TollList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports